// src/components/Auth/ProtectedRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { TOKEN_KEY, USER_DATA_KEY } from '../../services/api';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: ('admin' | 'affiliate' | 'student')[];
}

const loginByRole: Record<'admin' | 'affiliate' | 'student', string> = {
  admin: '/login-adm',
  affiliate: '/login/filiado',
  student: '/login/aluno',
};

const isValidRole = (role: unknown): role is 'admin' | 'affiliate' | 'student' => {
  return role === 'admin' || role === 'affiliate' || role === 'student';
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  const token = localStorage.getItem(TOKEN_KEY);
  const raw = localStorage.getItem(USER_DATA_KEY);

  let user: any = null;

  try {
    user = raw ? JSON.parse(raw) : null;
  } catch {
    user = null;
  }

  const role = user?.role;
  const targetLogin = loginByRole[allowedRoles[0] ?? 'student'];

  // sem token -> vai para o login da rota acessada
  if (!token) {
    return <Navigate to={targetLogin} replace />;
  }

  // token inválido / user inválido / role inválida -> limpa e vai para o login da rota acessada
  if (!user || !isValidRole(role)) {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_DATA_KEY);
    return <Navigate to={targetLogin} replace />;
  }

  // role não permitida para essa rota -> manda para o login da rota acessada
  if (!allowedRoles.includes(role)) {
    return <Navigate to={targetLogin} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;